import React from 'react';
import RealisedGainsSummaryVM from './RealisedGainsSummaryVM';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import RealisedGainsSummaryLookup from '../Models/Lookups/RealisedGainsSummaryLookup';
import { TextConstants } from '../../../Common/TextConstants';
import { dateFormatYYYYMMDD } from '../../../Common/Components/Helpers/Formatting';

interface IRealisedGainsSummaryProps {
    viewModel: RealisedGainsSummaryVM;
}

@observer
export default class RealisedGainsSummary extends React.Component<IRealisedGainsSummaryProps> {

    constructor(props: IRealisedGainsSummaryProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.viewModel;

        return (
          <>
          <Neo.Card>
            {viewModel.realisedGainsSummaryPageManager.totalRecords > 0 &&               
                <div className="inner-container">
                  <Neo.Pager
                    pageManager={viewModel.realisedGainsSummaryPageManager}
                    pageControlProps={{ pageSizeLabel: "Show" }}
                  >
                    <div className="horizontalScroll inner-container">
                      <NeoGrid.Grid<RealisedGainsSummaryLookup> className={"table-striped"}>
                        {(item, meta) => (
                          <NeoGrid.RowGroup>
                            <NeoGrid.Row>
                              <NeoGrid.Column display={meta.brokerAccountNumber} label={TextConstants.Labels.BrokerAccountNumber} />
                              <NeoGrid.Column label={TextConstants.Labels.EventDate}> {dateFormatYYYYMMDD(item.eventDate)} </NeoGrid.Column>
                              <NeoGrid.Column display={meta.instrument}   label={TextConstants.Labels.Instrument} />
                              <NeoGrid.Column display={meta.instrumentCode} label={TextConstants.Labels.InstrumentCode} />
                              <NeoGrid.Column display={meta.isin} label={TextConstants.Labels.Isin} />
                              <NeoGrid.Column display={meta.eventID} label={TextConstants.Labels.EventID} />
                              <NeoGrid.Column display={meta.eventName} label={TextConstants.Labels.EventName} />
                              <NeoGrid.Column display={meta.quantity} label={TextConstants.Labels.Quantity}/>
                              <NeoGrid.Column display={meta.proceedsNC} label={TextConstants.Labels.ProceedsNC} />
                              <NeoGrid.Column display={meta.baseValueSoldNC} label={TextConstants.Labels.BaseValueSoldNC} />
                              <NeoGrid.Column display={meta.realisedGainNC} label={TextConstants.Labels.RealisedGainNC} />
                            </NeoGrid.Row>
                          </NeoGrid.RowGroup>
                        )}
                      </NeoGrid.Grid>
                    </div>
                  </Neo.Pager>
                </div>
              }
                {viewModel.realisedGainsSummaryPageManager.totalRecords <= 0 && (
                  <div className="col-md-12 p-0 text-center">
                    {TextConstants.GeneralText.NoRecords}
                  </div>
                )}
              </Neo.Card>
           
          </>
        );
    }
}